package ai.jessie.web.invoices

import ai.jessie.web.theme.CardBodyStyle
import ai.jessie.web.theme.CardStyle
import ai.jessie.web.theme.FieldsetStyle
import ai.jessie.web.theme.Grid2Style
import ai.jessie.web.theme.HintStyle
import ai.jessie.web.theme.LegendStyle
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.style.toAttrs
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Fieldset
import org.jetbrains.compose.web.dom.Legend
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

// Steps 2-4: customer, currency and dates from the server's offer; a changed customer, currency
// or invoice date reloads the choices, so positions always match the current details.
@Composable
internal fun invoiceDetailsForm(state: InvoiceUiState, actions: InvoiceActions) {
    val draft = state.draft ?: return
    val options = state.options ?: return
    // The card is a plain box around the borderless fieldset, so the legend is not drawn on a
    // border.
    Div(attrs = CardStyle.toAttrs()) {
        Fieldset(attrs = FieldsetStyle.toAttrs { if (state.busy) attr("disabled", "") }) {
            Legend(attrs = LegendStyle.toAttrs()) { Text("Rechnungsdetails") }
            Div(attrs = CardBodyStyle.toAttrs()) {
                invoiceSelect(
                    InvoiceField(
                        "customerId",
                        "Kunde (Pflichtfeld, nur Kunden mit vollständiger Rechnungsadresse)",
                        draft.customerId,
                        state.problems["customerId"],
                    ),
                    options.customers.associate { it.id to it.name },
                ) { value ->
                    actions.changeDetails { it.copy(customerId = value) }
                    actions.reloadChoices()
                }
                options.customers
                    .firstOrNull { it.id == draft.customerId }
                    ?.let { customer ->
                        P(attrs = HintStyle.toAttrs()) {
                            Text(
                                "Rechnungsadresse: " +
                                    addressLines(customer.address).joinToString(", ")
                            )
                        }
                    }
                invoiceSelect(
                    InvoiceField(
                        "currency",
                        "Währung (Pflichtfeld)",
                        draft.currency,
                        state.problems["currency"],
                    ),
                    options.currencies.associateWith { it },
                ) { value ->
                    actions.changeDetails { it.copy(currency = value) }
                    actions.reloadChoices()
                }
                Div(attrs = Grid2Style.toAttrs()) { dateFields(state, actions) }
            }
        }
    }
}

@Composable
private fun dateFields(state: InvoiceUiState, actions: InvoiceActions) {
    val draft = state.draft ?: return
    invoiceInput(
        InvoiceField(
            "issueDate",
            "Rechnungsdatum (Pflichtfeld, vorgeschlagen: heute in der Zeitzone der Organisation)",
            draft.issueDate,
            state.problems["issueDate"],
        ),
        InputType.Date,
    ) { value ->
        actions.changeDetails { it.copy(issueDate = value) }
        actions.reloadChoices()
    }
    invoiceInput(
        InvoiceField(
            "dueDate",
            "Fälligkeitsdatum (Pflichtfeld, vorgeschlagen aus den Zahlungsbedingungen)",
            draft.dueDate,
            state.problems["dueDate"],
        ),
        InputType.Date,
    ) { value ->
        actions.changeDetails { it.copy(dueDate = value, dueDateProposed = false) }
    }
}
